import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/shadcn/ui/button';
import { Input } from '@/components/shadcn/ui/input';

interface SharedLinkPasswordFormProps {
  isLoading: boolean;
  hasError: boolean;
  onSubmit: (password: string) => void;
}

export const SharedLinkPasswordForm = ({
  isLoading,
  hasError,
  onSubmit,
}: SharedLinkPasswordFormProps) => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password.trim()) {
      onSubmit(password);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-white">
      <div className="flex w-full max-w-sm flex-col items-center px-6">
        <div
          style={{ width: 24, height: 24, cursor: 'pointer' }}
          onClick={() => navigate('/')}
        >
          <img
            src="/assets/logo-rebranding-syncly.svg"
            width="100%"
            height="100%"
            alt="Syncly"
          />
        </div>

        <h1 className="mt-6 text-2xl font-semibold text-gray-900">
          Password required
        </h1>

        <p className="mt-2 text-center text-gray-500">
          This report is password protected.
        </p>

        <form onSubmit={handleSubmit} className="mt-6 w-full">
          <Input
            type="password"
            placeholder="Enter password..."
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full"
            autoFocus
          />

          {hasError && (
            <p className="mt-2 text-center text-sm text-red-500">
              The password is incorrect. Please try again.
            </p>
          )}

          <Button
            type="submit"
            variant="default"
            className="mt-4 w-full"
            disabled={isLoading || !password.trim()}
          >
            {isLoading ? 'Verifying...' : 'Continue'}
          </Button>
        </form>
      </div>
    </div>
  );
};
